import { Persistable, property, Supertype, supertypeClass } from '@haventech/amorphic';

@supertypeClass({ toClient: false, toServer: false })
export class CustomerActiveApplications extends Persistable(Supertype) {
  static new(customerId: string, activeApps: Array<string>, applicationId: string) {
    return new CustomerActiveApplications().init(customerId, activeApps, applicationId);
  }
  private init(customerId: string, activeApps: Array<string>, applicationId: string): this {
    this.customerId = customerId;
    this.activeAppIds = activeApps;
    this.activeAppNum = activeApps.length;
    this.currentAppId = applicationId;
    return this;
  }

  constructor() {
    super();
  }
  @property()
  customerId: string;

  @property()
  currentAppId: string;

  @property()
  activeAppNum: number;

  @property({ type: Array, getType: () => String })
  activeAppIds: Array<string> = [];

  async save() {
    return this.persistSave();
  }
}
